/**
 * validationMethods.js — Form Validation Utilities
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. Fixed all == to === and != to !==
 *  2. Removed stray semicolons after return <span> in vinValidate
 *  3. isValidForm / isValidFormWithCondtionalSkip: .map → .forEach (no return needed)
 *  4. Consistent null/undefined checks
 */

import React from 'react';
import validator from 'validator';

export const required = (value, props) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return <span className="has-danger">{props.requiredmsg}</span>;
  }
  if (!value.toString().trim().length) {
    return <span className="has-danger">{props.requiredmsg}</span>;
  }
};

export const reqReleaseInfo = (value, props) => {
  if (props.isRelease) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return <span className="has-danger">{props.requiredmsg}</span>;
    }
  }
};

export const CondRequired = (value, props) => {
  if (!props.skipValidation) {
    if (typeof value === 'undefined' || value === null || (value || '') === '') {
      return <span className="has-danger">{props.requiredmsg}</span>;
    }
    if (!value.toString().trim().length) {
      return <span className="has-danger">{props.requiredmsg}</span>;
    }
  }
};

export const requiredSelect = (value, props) => {
  if (typeof value === 'undefined' || value === null) {
    return <span className="error">Please select {props.name}</span>;
  }
  if (!value.toString().trim().length) {
    return <span className="error">Please select {props.name}</span>;
  }
};

export const phoneNo = (value, props) => {
  if (
    value !== undefined &&
    value !== null &&
    (value.toString().trim().length < props.maxLength ||
      value.toString().trim().length > props.maxLength)
  ) {
    return <span className="error">Invalid phone number.</span>;
  }
};

export const email = (value, props) => {
  if (value !== undefined && value !== null && value !== '' && !validator.isEmail(value)) {
    return <span className="has-danger">Please enter valid email.</span>;
  }
};

export const patterncheck = (value, props) => {
  if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(value)) {
    return (
      <span className="has-danger">
        * Password must be at least 8 characters with at least 1 uppercase letter, 1 lowercase
        letter, and 1 number.
      </span>
    );
  }
};

export const compare = (value, props) => {
  if (value !== props.compareVal) {
    return <span className="has-danger">Your password and confirm password do not match.</span>;
  }
};

export const phone = (value, props) => {
  if (value !== undefined && value !== null && value !== '' && !validator.isMobilePhone(value, 'en-US')) {
    return <span className="has-danger">Please enter valid phone.</span>;
  }
};

export const fax = (value, props) => {
  if (value !== undefined && (value || '') !== '' && !validator.isMobilePhone(value, 'en-US')) {
    return <span className="has-danger">Please enter valid fax.</span>;
  }
};

export const zipValidation = (value, props) => {
  if (value !== undefined && value !== null && value !== '' && !validator.isPostalCode(value, 'US')) {
    return <span className="has-danger">Please enter valid zip code.</span>;
  }
};

export const isAlphanumeric = (value, props) => {
  if (value !== undefined && value !== null && !validator.isAlphanumeric(value, 'en-US')) {
    return <span className="has-danger">Please enter Alpha Numeric Only.</span>;
  }
};

export const isNumeric = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (!validator.isNumeric(value.toString())) {
      return <span className="has-danger">Please enter Numeric Only.</span>;
    }
  }
};

export const NotZero = (value, props) => {
  if (parseFloat(value) < 1) {
    return <span className="has-danger">Value must be greater then zero.</span>;
  }
};

export const NonNegative = (value, props) => {
  if (value === '' || value === null || value === undefined) return;
  if (isNaN(parseFloat(value)) || parseFloat(value) < 0) {
    return <span className="has-danger">Value must be zero or greater.</span>;
  }
};

export const vinValidate = (vin, props) => {
  if ((vin || '') === '') return;

  if (vin === '11111111111111111') {
    return <span className="has-danger">VIN should be 17 alphanumeric characters.</span>;
  }

  if (vin.length !== 17 || !alphanumeric(vin)) {
    return <span className="has-danger">VIN should be 17 alphanumeric characters.</span>;
  }

  if (!vin.match('^([0-9a-hj-npr-zA-HJ-NPR-Z]{10,17})+$')) {
    return <span className="has-danger">Invalid VIN number.</span>;
  }

  const letters = [
    { k: 'A', v: 1 }, { k: 'B', v: 2 }, { k: 'C', v: 3 },
    { k: 'D', v: 4 }, { k: 'E', v: 5 }, { k: 'F', v: 6 }, { k: 'G', v: 7 },
    { k: 'H', v: 8 }, { k: 'J', v: 1 }, { k: 'K', v: 2 }, { k: 'L', v: 3 },
    { k: 'M', v: 4 }, { k: 'N', v: 5 }, { k: 'P', v: 7 }, { k: 'R', v: 9 },
    { k: 'S', v: 2 }, { k: 'T', v: 3 }, { k: 'U', v: 4 }, { k: 'V', v: 5 },
    { k: 'W', v: 6 }, { k: 'X', v: 7 }, { k: 'Y', v: 8 }, { k: 'Z', v: 9 },
  ];
  const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  const exclude = ['I', 'O', 'Q'];

  let val = 0;
  for (let idx = 0; idx < vin.length; idx++) {
    const item = vin.charAt(idx).toUpperCase();
    if (exclude.includes(item)) {
      return <span className="error">VIN should be 17 alphanumeric characters.</span>;
    }
    const pos =
      item.match('^[0-9]+$') !== null
        ? parseInt(item, 10)
        : letters.find((letter) => letter.k === item).v;
    val += pos * weights[idx];
  }

  const checksum = val % 11;
  if (vin.charAt(8) !== (checksum < 10 ? checksum.toString() : 'X')) {
    return <span className="has-danger">Invalid VIN number.</span>;
  }
};

export const isYear = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (!/^\d{4}$/.test(value)) {
      return <span className="has-danger">Year should be 4 digits.</span>;
    }
  }
};

export const isMileage = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (value.length > 8) {
      return <span className="has-danger">Max. length should be 8 digits.</span>;
    }
    if (!/^[0-9]*$/.test(value)) {
      return <span className="has-danger">Please enter Digits Only.</span>;
    }
  }
};

export const isGreaterOrEqual = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (parseInt(value, 10) < parseInt(props.compareTo, 10)) {
      return <span className="has-danger">{props.comparemsg}</span>;
    }
  }
};

export const isDecimal = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (!/(?:\d*\.\d{1,2}|\d+)$/.test(value)) {
      return <span className="has-danger">{props.errormsg}</span>;
    }
  }
};

export const toInt = (value, props) => {
  if (value !== '' && value !== undefined && value !== null && !validator.toInt(value)) {
    return <span className="has-danger">Please enter integer values Only.</span>;
  }
};

export const isCurrency = (value, props) => {
  if (value !== '' && value !== undefined && value !== null && !validator.isCurrency(String(value))) {
    return <span className="has-danger">Please enter a valid currency.</span>;
  }
};

export const isPercentage = (value, props) => {
  if (
    value !== '' &&
    value !== undefined &&
    value !== null &&
    !validator.isDecimal(String(value), { decimal_digits: '0,2' })
  ) {
    return <span className="has-danger">Must not have more than 2 decimal places.</span>;
  }
};

export const isValidForm = (formObj) => {
  let invalidCount = 0;
  Object.keys(formObj.state.byId).forEach((item) => {
    if (Object.keys(formObj.state.byId[item].error || {}).length > 0) {
      invalidCount++;
    }
  });
  return invalidCount === 0;
};

export const isValidFormWithCondtionalSkip = (formObj) => {
  let invalidCount = 0;
  Object.keys(formObj.state.byId).forEach((item) => {
    if (Object.keys(formObj.state.byId[item].error || {}).length > 0) {
      invalidCount++;
    }
  });
  return invalidCount === 0;
};

export const isLenghtOf = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (value.length !== props.length) {
      return <span className="has-danger">{props.lengthofmsg}</span>;
    }
  }
};

export const subdomainValidation = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (!/^[a-zA-Z0-9]*$/.test(value)) {
      return (
        <span className="has-danger">
          Invalid subdomain name. Please enter valid subdomain, Which contains only alphanumeric value.
        </span>
      );
    }
  }
};

export const isValidDomain = (value, props) => {
  if (!props.isValid) {
    return <span className="has-danger">Subdomain exits. Please Change the domain name</span>;
  }
};

export const isValidEmail = (value, props) => {
  if (!props.isValid) {
    return <span className="has-danger">Email id already exists. Please use another email id.</span>;
  }
};

export const validateUser = (value, props) => {
  if (!props.isValid) {
    return <span className="has-danger">User id already exists. Please use different.</span>;
  }
};

export const maxLength = (value, props) => {
  if (value !== '' && value !== undefined && value !== null) {
    if (value.length > props.maxTextLength) {
      return <span className="has-danger">{props.maxLengthMessage}</span>;
    }
  }
};

/** Check if a string contains both letters and digits */
export const alphanumeric = (input) => {
  return /\d/.test(input) && /[a-zA-Z]/.test(input);
};
